// 产品页数据 页头搜索通用
const productsData = [
    [
        {
            title:'XLIM PRO 4',
            info:'· Anti-Burn Tech<br>· UNITECH 3.0 Taste<br>· 1800mAh & 3A Charge',
            url:'/xlim-pro-4',
            kits:'https://drive.google.com/drive/folders/1h9d4QTORKd1fA02oph6H4bVD8L9cRntd',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_PRO_4.avif?v=1791886086',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_RPO_4_01_daecfee5-b53a-483f-ae8d-e569b341b77f.avif?v=1791943415'
        },
        {
            title:'XLIM 4',
            info:'· 3-Level Power<br>· XLIM New Cartridge<br>· 1600mAh & 2A Fast Charging',
            url:'/xlim-4',
            kits:'https://drive.google.com/drive/folders/1_KBI49Z_hSCCU2b5tOOOAY-Ooc_s0I-p',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM-4.avif?v=1790650860',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM-4--2.avif?v=1790650860'
        },
        {
            title:'XLIM GO LITE',
            info:'· Easy to Use<br>· 1000mAh Battery<br>· 3mL Refillable Pod',
            url:'/xlim-go-lite',
            kits:'https://drive.google.com/drive/folders/1KrBGLKcjqS1hjDbJFsBqO_yHXTkHNUhJ',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_GO_LITE_1a1f15cd-3786-4472-8926-24f208f7a4b0.avif?v=1780020602',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_GO_LITE_01.avif?v=1776044646'
        },
        {
            title:'XLIM PRO 3',
            info:'· OXVA 1<sup>st</sup> Pulse System<br>· 1.05" HD Display<br>· 1500mAh & Fast Charging',
            url:'/xlim-pro-3',
            kits:'https://drive.google.com/drive/folders/1A4khswk2L20kCgtUwJMoqd908CA1qhKy',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_PRO_3_NC.avif?v=1787040780',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_PRO_3_01.avif?v=1765938621'
        },
        {
            title:'XLIM 3 ULTRA',
            info:'· OXVA 1<sup>st</sup> Super Pulse System<br>· 2.2" HD Full Touch Screen<br>· 1500mAh & Fast Charging',
            url:'/xlim-3-ultra',
            kits:'https://drive.google.com/drive/folders/1vZBvvSs6Wgjk9GSXHm9am9zhAN-PT8mI',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_3_ULTRA_new_awards.avif?v=1786349042',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_3_ULTRA_01.avif?v=1765935785'
        },
        {
            title:'XLIM GO 2',
            info:'· Unitech 2.0 Taste<br>· 3ml New XLIM Pod<br>· 1500mAh & 2A Fast Charging',
            url:'/xlim-go-2',
            kits:'https://drive.google.com/drive/folders/1Tfb0kntkv6qyd_NQd15gx1Z97g98-uNb',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_GO_2_NC.avif?v=1785292346',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_GO_2_NC_01.avif?v=1785292346'
        },
        {
            title:'XLIM PRO 2 DNA Version',
            info:'· Never Dry Hit<br>· Never Flavor Fade<br>· Smart Flavor Replay',
            url:'/xlim-pro-2-dna',
            kits:'https://drive.google.com/drive/folders/10tF2nLOlxEu9ujhNC5WGZYi7QUKG30_B',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_PRO_2_DNA_2cb4e5e8-d2e8-443b-a7ca-7532f81efb14.avif?v=1770632350',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_PRO_2_DNA_01.avif?v=1765938621'
        },
        {
            title:'XLIM SQ PRO 2',
            info:'· Smart Touch Screen<br>· 1600mAh Battery<br>· Intelligent Puff Diary',
            url:'/xlim-sq-pro-2',
            kits:'https://drive.google.com/drive/folders/18_ePiMNtLsZw3BDjGy2fJJzju9UkhnCE',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_SQ_PRO_2_4c8378d1-d1bd-49a5-a4e2-8883b1494833.avif?v=1765938621',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_SQ_PRO_2_01.avif?v=1765938621'
        },
        {
            title:'XLIM PRO 2',
            info:'· HD Color Screen<br>· 1300mAh Battery<br>· 30W Max Output',
            url:'/xlim-pro-2',
            kits:'https://drive.google.com/drive/folders/1CuP2JW5f_9_og-kOxAuRG3T2o51hlMPa',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_PRO_2_3ba51614-1c11-4cca-bfa3-86812fb2ef97.avif?v=1765938621',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_PRO_2_01.avif?v=1765938621'
        },
        {
            title:'XLIM CLASSIC EDITION',
            info:'· 30W Max Power<br>· 1000mAh Battery<br>· OLED Screen',
            url:'/xlim-classic',
            kits:'https://drive.google.com/drive/folders/1vcXDGVjd7FVmt8tRegu_aEuys351v74k',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_CLASSIC_EDITION.avif?v=1765938621',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_CLASSIC_EDITION_01.avif?v=1765938621'
        },
        {
            title:'XLIM GO',
            info:'· 30W Max Output Power<br>· Precise Airflow Control<br>· New Skin-pasting Tech',
            url:'/xlim-go',
            kits:'https://drive.google.com/drive/folders/1W9U3Bcu1CPjYXnQ7xVUztAlSn-q3YtWO',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_GO_d5b55962-0828-4559-9b88-a582106621e0.avif?v=1765938621',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_GO_01.avif?v=1765938621'
        },
        {
            title:'XLIM SQ PRO',
            info:'· 30W Max Output Power<br>· 0.96” TFT Color Screen<br>· Optional Dynamic Themes',
            url:'/xlim_sq_pro',
            kits:'https://drive.google.com/drive/folders/1cq8sCeT8ErO3cGONPnaG7mRkkcIhOtEK',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_SQ_PRO_0d8f254c-3e89-408f-9608-024b883b2d54.avif?v=1765938621',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_SQ_PRO_01.avif?v=1765938621'
        },
        {
            title:'XLIM PRO',
            info:'· Glittering RGB light<br>· Anti-leak Top-fill Cartridges<br>· Highly Leak-resistant',
            url:'/xlim_pro',
            kits:'https://drive.google.com/drive/folders/1qHh1E19LGHjicA9KpAbG-i2GJdXQAcr7',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_PRO_6258af78-380b-4c47-ab42-ea780094ae66.avif?v=1765938621',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_PRO_01.avif?v=1765938621'
        },
        {
            title:'XLIM SE 2',
            info:'· 30W Max Output Power<br>· 1000mAh Bigger Battery<br>· XLIM Cartridge Compatible',
            url:'/xlim-se-2',
            kits:'https://drive.google.com/drive/folders/1vnPdXzlOF2vTu0AKTIiPiqVycByOVFk2',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_SE_2.avif?v=1765938621',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_SE_2_01.avif?v=1765938621'
        },
        {
            title:'XLIM POD',
            info:'· Highly Leak-resistant<br>· Ergonomic AFC<br>· Auto-draw & Manual',
            url:'/xlim-new-color',
            kits:'https://drive.google.com/drive/folders/1zWrz1oA7thppTkTqCZMP1BmHtsOEjJue',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_POD.avif?v=1765938621',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_POD_01.avif?v=1765938621'
        },
        {
            title:'XLIM SE',
            info:'· Highly Leak-resistant<br>· Ergonomic AFC<br>· High Compatibility',
            url:'/xlimse',
            kits:'https://drive.google.com/drive/folders/1gk8_8avJYM_wff8KLwaK5txuDKduQpAL',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_SE.avif?v=1765938621',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_SE_01.avif?v=1765938621'
        },
        {
            title:'XLIM SQ',
            info:'· 25W Max Output Power<br>· Highly Leak-resistant<br>· High Compatibility',
            url:'/xlim-sq',
            kits:'https://drive.google.com/drive/folders/1dgiUxr-CYGRjkHKdHhdZc4uarW5VFU1R',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_SQ.avif?v=1765938621',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_SQ_01.avif?v=1765938621'
        },
        {
            title:'XLIM C',
            info:'· XLIM C Coils (0.6Ω&0.8Ω&1.2Ω)<br>· Highly Leak-resistant<br>· Ergonomic AFC',
            url:'/xlimc',
            kits:'https://drive.google.com/drive/folders/1Il4CYXUwqjwbtTQ8O7iiuUCfjtV4ZU9K',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_C.avif?v=1765938621',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_C_01.avif?v=1765938621'
        },
        {
            title:'XLIM SE (Classic Edition)',
            info:'· Highly Leak-resistant<br>· Ergonomic AFC<br>· High Compatibility',
            url:'/xlim-se-classic-edition',
            kits:'https://drive.google.com/drive/folders/1vSN9Ndu4do50_RYyOP8h-7d5NvKf4IOa',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_SE_Classic_Edition.avif?v=1765938621',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_SE_Classic_Edition_01.avif?v=1765938621'
        }
    ],
    [
        {
            title:'NeXLIM 2',
            info:'· 0.85" Color Screen<br>· 4ML New Cartridge<br>· 2000mAh · 3A Charge',
            url:'/nexlim-2',
            kits:'https://drive.google.com/drive/folders/12Swm7htuBlgVwZZOChIufdzhtulb-MHF',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM_2_1_9c563d19-9a96-4e85-805a-84d830755ab3.avif?v=1785382754',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM_2_2.avif?v=1782213096'
        },
        {
            title:'NeXLIM 2 MINI',
            info:'· Premium Aluminum Build<br>· 4ML New Cartridge<br>· Touch Switch BOOST/ECO',
            url:'/nexlim-2-mini',
            kits:'https://drive.google.com/drive/folders/1xEGKKNcQvGuT01eFFFqTOHJl8smCyuyx',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM_2_MINI.avif?v=1782444338',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM_2_MINI_2.avif?v=1782444338'
        },
        {
            title:'NeXLIM GO',
            info:'· Dual Mesh Technology<br>· Boost & Eco Modes<br>· 1800mAh Fast-charging',
            url:'/nexlim-go',
            kits:'https://drive.google.com/drive/folders/1dWQwxTkYyHpBTh8J3aWrWA71cyb9B_hq',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM_GO_dabbe1ef-6576-440d-a87a-c57fb2e2c96d.avif?v=1789009088',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM-GO-01.avif?v=1789009088'
        },
        {
            title:'NeXLIM',
            info:'· Dual Mesh Technology<br>· Boost & Eco Modes<br>· 4ml Large Capacity Pod',
            url:'/nexlim',
            kits:'https://drive.google.com/drive/folders/1WjYpS1LpbbtmytHT7irTRXw1FFGj5syv',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM_84119bc5-30f2-428b-87fa-b103204e6944.avif?v=1765942847',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM_01.avif?v=1765942848'
        }
    ],
    [
        {
            title:'SLIMSTICK NANO',
            info:'· All-Metal Design<br>· Ultra Slim & Handy<br>· 2ml Cig-Like Prefilled Pods',
            url:'/slimstick-nano',
            kits:'https://drive.google.com/drive/folders/1u9VMVUOrv1gtmQU_w2r-q_vPQ5IUx7s2',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Slimstick_Nano.avif?v=1789434820',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Slimstick_Nano_01.avif?v=1789434820'
        },
        {
            title:'SLIMSTICK X',
            info:'· All-Metal Body<br>· 1400mAh Battery, 5 Day\'s Use<br>· 2ml Refillable Pods',
            url:'/slimstick-x',
            kits:'https://drive.google.com/drive/folders/1mgui8gAu5c_QbyVlhrEEjsoqQbGqddM0',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Slimstick_X_1ef24f8b-76d7-4f89-8053-1f0d91abea92.avif?v=1778635492',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/Slimstick_X_01.avif?v=1770632169'
        },
        {
            title:'SLIMSTICK',
            info:'· 1500mAh Powerful Battery<br>· 2ml Cig-like Prefilled Pods<br>· Multiple Flavour Choices',
            url:'/slimstick',
            kits:'https://drive.google.com/drive/folders/1x96JFhzcX4PvBdPBme4FIDkOe2fFl2Ml',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/SLIMSTICK_awards.avif?v=1767754813',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/SLIMSTICK_01.avif?v=1765943503'
        }
    ],
    [
        {
            title:'VPRIME 2',
            info:'· 3400mAh Power<br>· 60W Auto Draw<br>· 6ML Dual Mesh',
            url:'/vprime-2',
            kits:'https://drive.google.com/drive/folders/1-ZZvk8A0hG_PqRaY2xD7KqJpzCcPbFZJ',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/VPRIME_2_c367ac44-582f-4166-9249-f508d689b6ed.avif?v=1788922819',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/VPRIME_2_01.avif?v=1788917618'
        },
        {
            title:'VPRIME',
            info:'· Auto-draw DTL Pod<br>· 3D Vivid Screen<br>· 2600mAh Huge Battery',
            url:'/vprime',
            kits:'https://drive.google.com/drive/folders/1yoJAtGYFvvmYkdCjssDv4jxwTqGK52cl',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/VPRIME_2d17c000-c575-44b2-990a-5054170d87fb.avif?v=1765943503',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/VPRIME_01.avif?v=1765943503'
        }
    ],
    [
        {
            title:'XLIM ABT CARTRIDGE<br> UNITECH 3.0',
            info:'· Anti-Burn Tech<br>· 30s Priming<br>· 100% Anti-Leak',
            url:'/xlim-pro-4',
            kits:'https://drive.google.com/drive/folders/1h9d4QTORKd1fA02oph6H4bVD8L9cRntd',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_ABT_Cartridge.avif?v=1791886086',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_ABT_Cartridge_01_97d07722-f5d3-4fe0-a7f6-9af6c29b8f84.avif?v=1791943415'
        },
        {
            title:'XLIM TOP FILL CARTRIDGE<br> UNITECH 3.0',
            info:'· Unitech 3.0 Taste<br>· 30s Priming<br>· 100% Anti-Leak',
            url:'/xlim-top-fill-cartridge-unitech-3',
            kits:'https://drive.google.com/drive/folders/1SwwuwV1hdEIPSrMcDHUNlvLB_aUcD5qP?usp=sharing',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_4_Cartridge_UNITECH_3.0.avif?v=1789438848',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_4_Cartridge_UNITECH_3.0_01_a7b2d1ba-ae14-400b-848f-a9ca393cb074.avif?v=1789440541'
        },
        {
            title:'XLIM TOP FILL CARTRIDGE 3ML',
            info:'· Unitech 2.0 Taste<br>· 5 Layers Leak-proof<br>· XLIM Series Compatible',
            url:'/xlim-refillable-cartridge',
            kits:'https://drive.google.com/drive/folders/1NtsVf-D8Mz4ISC8y5UtrqVN_kwxotn0n',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_TOP_FILL_CARTRIDGE_3ML.avif?v=1765951670',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_TOP_FILL_CARTRIDGE_3ML_01.avif?v=1766040159'
        },
        {
            title:'XLIM TOP FILL CARTRIDGE SS',
            info:'· No Dry Hits<br>· No Flavor Fades<br>· T-Control & Flavor Replay',
            url:'/xlim-pro-2-dna',
            kits:'https://drive.google.com/drive/folders/1zuhlK1_tV7SE7RljGq5s7nbPgnSBTTgr',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_TOP_FILL_CARTRIDGE_SS_f6215a6b-2e35-4c06-889a-f25c02e9ace7.avif?v=1765951670',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_TOP_FILL_CARTRIDGE_SS_01.avif?v=1766040159'
        },
        {
            title:'XLIM EZ CARTRIDGE',
            info:'· Easy Top Fill<br>· 3ml Large Capacity<br>· Highly Leak-proof',
            url:'/xlim-ez-cartridge',
            kits:'https://drive.google.com/drive/folders/1_8_LaEb0uv7h8Xf8FuacXu9zfL9UbXmI',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_EZ_CARTRIDGE.avif?v=1765951670',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_EZ_CARTRIDGE_01.avif?v=1766040159'
        },
        {
            title:'XLIM TOP FILL CARTRIDGE 2ML',
            info:'· X-Treme Flavor<br>· Highly Leak-resistant<br>· XLIM Series Compatible',
            url:'/xlim-refillable-cartridge',
            kits:'https://drive.google.com/drive/folders/1DSyajgm0XlN_Mx3a-7xeKz_56_Inh1Zj',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_TOP_FILL_CARTRIDGE_2ML.avif?v=1765951670',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_TOP_FILL_CARTRIDGE_2ML_01.avif?v=1766040159'
        },
        {
            title:'NeXLIM CARTRIDGE UNITECH 3.0',
            info:'· 3x Enhanced Anti-Leak<br>· Ultra-Smooth Hits<br>· Super Original Flavor',
            url:'/nexlim-cartridge-unitech3',
            kits:'https://drive.google.com/drive/folders/1Uo--I8sTCmVRnOnATDUmEEN79jqNWZyd',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM_CARTRIDGE_V2.avif?v=1782467421',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM_CARTRIDGE_V2_02.avif?v=1782467572'
        },
        {
            title:'NeXLIM CARTRIDGE',
            info:'· Dual Mesh Technology<br>· More Than 30 Refills<br>· 5 Layers Leak-proof',
            url:'/nexlim-refillable-cartridge',
            kits:'https://drive.google.com/drive/folders/1EHGgRlrqNm2_SmBFgFDblcMh3c943Cez',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM_CARTRIDGE.avif?v=1765951670',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM_CARTRIDGE_01.avif?v=1766040159'
        },
        {
            title:'VPRIME Dual Mesh Cartridge',
            info:'· 6ML Dual Mesh<br>· Unitech 3.0 Taste<br>· VPRIME Series Compatible',
            url:'/vprime-2',
            kits:'https://drive.google.com/drive/folders/10qu-iZkOhQR2tV3M21av6_lpqEU-gnk0?usp=drive_link',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/VPRIME_Dual_Mesh_Cartridge_8b4dbd2b-6891-4003-b8be-86a3e5b238ff.avif?v=1788923030',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/VPRIME_Dual_Mesh_Cartridge_01.avif?v=1788921749'
        },
        {
            title:'SLIMSTICK X CARTRIDGE',
            info:'· All-Metal Body<br>· 1400mAh Battery, 5 Day\'s Use<br>· 2ml Refillable Pods',
            url:'/slimstick-x',
            kits:'https://drive.google.com/drive/folders/1jI5NsIk-U3uLeUwi1JtJELQko-33HZBG',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/SLIMSTICK_X_CARTRIDGE_d93c21d0-daa8-4557-b72d-77ac280c2421.avif?v=1770633507',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/SLIMSTICK_X_CARTRIDGE_01.avif?v=1770633507'
        },
        {
            title:'SLIMSTICK CARTRIDGE',
            info:'· 2ml Cig-like Pods<br>· 20mg/ml Nicotine<br>· 11 Flavor Choices',
            url:'/slimstick',
            kits:'https://drive.google.com/drive/folders/1I_ugU7iySqND0F-sMQIhh6VybG5sirnC',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/SLIMSTICK_CARTRIDGE.avif?v=1765951670',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/SLIMSTICK_CARTRIDGE_01.avif?v=1766040159'
        },
        {
            title:'ARTIO 2 CARTRIDGE',
            info:'· 2ml Liquid Tobacco<br>· 8 & 18mg/ml Nicotine<br>· 5 Tobacco Flavors',
            url:'/artio-2',
            kits:'https://drive.google.com/drive/folders/1tmKN6O4uKbJqT6f2lgsYB6pV4yKHfMTW',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ARTIO_2_CARTRIDGE_018fe448-3376-46a4-940b-828920f7136a.avif?v=1765951670',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ARTIO_2_CARTRIDGE_01.avif?v=1766040159'
        },
        {
            title:'VPRIME CARTRIDGE',
            info:'· 5ml Large Capacity<br>· 5 Layers Leak-proof<br>· Unitech 2.0 Taste',
            url:'/vprime',
            kits:'https://drive.google.com/drive/folders/1oCmlZeXoKa0BVKWgVouQ0hsG-Ly-QASX',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/VPRIME_CARTRIDGE.avif?v=1765951670',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/VPRIME_CARTRIDGE_01.avif?v=1766040159'
        }
    ],
    [
        {
            title:'ARTIO',
            info:'· Signature Pen Style<br>· 1000mAh Battery<br>· 0.8Ω Pure MTL',
            url:'/products',
            kits:'https://drive.google.com/drive/folders/1Arylp2UnuhMUBClanZnDeidhzME3CEPb',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ARTIO_1f9516c9-e9ca-4a2c-a000-5e64c94f668f.avif?v=1778227717',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ARTIO_01_a09e699c-88af-49d2-b4a1-2cf406049580.avif?v=1778227717'
        },
        {
            title:'ARTIO 2',
            info:'· Pure Liquid Tobacco<br>· Tobacco Flavor Activation System<br>· Intelligent Control Engine',
            url:'/artio-2',
            kits:'https://drive.google.com/drive/folders/1j8WlSo7ZsFMfKtSPgpG-Q3Vn0oXm6iDx',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ARTIO_2.avif?v=1765942847',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ARTIO_2_01.avif?v=1765942848'
        },
        {
            title:'ONEO PRO',
            info:'· 40W Max Output Power<br>· 0.96" Full-Color Display<br>· 2100mAh Battery',
            url:'/oneo-pro',
            kits:'https://drive.google.com/drive/u/0/folders/1kZHxAZNUjlwTwVS454dO0YKVjsl3f8IX',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ONEO-PRO_1.avif?v=1783474058',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ONEO-PRO.avif?v=1783474058'
        },
        {
            title:'UNIONE',
            info:'· 10 ML Mega Pod<br>· Easy & Fast Top-Fill<br>· 1100 mAh Battery',
            url:'/unione',
            kits:'https://drive.google.com/drive/u/1/folders/1rF3J8Ivpa_ipZ8wV7wKbVyhGICmVmvoN',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/UNIONE.avif?v=1778635492',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/UNIONE_01.avif?v=1778635492'
        },
        {
            title:'ONEO',
            info:'· Unicoil Technology<br>· 1600mAh Large Battery<br>· 40W Max Power',
            url:'/oneo',
            kits:'https://drive.google.com/drive/folders/1KI0YthwFkSgu9X81soKtB3K7J3yGYwot',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ONEO_2b08f54a-b4d9-43d3-b774-a245005dedfe.avif?v=1765942848',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ONEO_01.avif?v=1765942847'
        },
        {
            title:'ORIGIN SE',
            info:'· 40W Max Output<br>· Auto-draw & Manual<br>· Unicoil System',
            url:'/originse',
            kits:'https://drive.google.com/drive/folders/1EmGI3End1UCAy8EczEqhkgZQulKdoWtm',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ORIGIN_SE.avif?v=1765943503',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ORIGIN_SE_01.avif?v=1765943503'
        },
        {
            title:'ORIGIN 2',
            info:'· Upgraded Leak Protection<br>· Compact Unicoil & Uniplus Coil<br>· 80W Max Output',
            url:'/origin2',
            kits:'https://drive.google.com/drive/folders/1kDsmK8_PGS-Z22p3b3GQdwabGZPV5D1z',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ORIGIN_2.avif?v=1765943503',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ORIGIN_2_01.avif?v=1765943503'
        },
        {
            title:'ORIGIN MINI',
            info:'· Stylish & Pocket-friendly<br>· 2200mAh Internal Battery<br>· 2200mAh Internal Battery',
            url:'/origin-mini',
            kits:'https://drive.google.com/drive/folders/1HqNOIhkJulMdI9v-zFSMnwvzbcNhn2-Z',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ORIGIN_MINI.avif?v=1765943503',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ORIGIN_MINI_01.avif?v=1765943503'
        },
        {
            title:'ORIGIN X',
            info:'· Multiple Vaping Experience<br>· Innovative Dual Coil RBA<br>· Magnetic Cartridge',
            url:'/origin-x',
            kits:'https://drive.google.com/drive/folders/1dcnWZPwM1ozrkDET_-oo15077lUrfvIt',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ORIGIN_X.avif?v=1765943503',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ORIGIN_X_01.avif?v=1765943503'
        },
        {
            title:'ARBITER 2',
            info:'· Fanned Airflow Structure<br>· Top-to-bottom Airflow Design<br>· 100% Leak proof',
            url:'/arbiter2',
            kits:'https://drive.google.com/drive/folders/15I109d7K41kxPxLUVinucqGc6Z6X1foR',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/arbiter-2.avif?v=1765943503',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/arbiter-2_01.avif?v=1765943503'
        },
        {
            title:'ARBITER RTA',
            info:'· Awesome Flavor<br>· Easy to Build<br>· Big Capacity(6ml)',
            url:'/product-arbiter-solo-rta',
            kits:'https://drive.google.com/drive/folders/1N5SxTZJTZcTSBKPoH8D3PRRHuVJlm9Pl',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/arbiter-rta.avif?v=1765943503',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/arbiter-rta_01.avif?v=1765943503'
        },
        {
            title:'VELOCITY LE',
            info:'· 100W Max Output<br>· 3 Modes (smart&power&voltage)<br>· Unique 510 Connector',
            url:'/velocity-le',
            kits:'https://drive.google.com/drive/folders/14HQsZUoGl_vCxN-jDlIzS21hu3HJa7Uo',
            img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/VELOCITY_LE.avif?v=1765943503',
            maskImg:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/VELOCITY_LE_01.avif?v=1765943503'
        }
    ]
]